import React from "react";

export default function SignInIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H6M9.33333 4.66667L6 8L9.33333 11.3333M6 8H14"
        stroke="#71717A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
